import { render, staticRenderFns } from "./ProductConfiguration.vue?vue&type=template&id=52716cde"
import script from "./ProductConfiguration.vue?vue&type=script&lang=js"
export * from "./ProductConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ProductConfiguration.vue?vue&type=style&index=0&id=52716cde&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports